import isEqual from 'lodash/isEqual';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTreatments } from 'store/split/splitSelectors';
import { fetchDeals } from 'store/promoArea/promoAreaActions';
import { getLocationDealsQuery } from 'store/search/searchSelectors/querySelectors';

const PromoAreaDealsFetcher = () => {
  const dispatch = useDispatch();
  const [previousQuery, setPreviousQuery] = useState(null);

  const query = useSelector(getLocationDealsQuery);
  const splitTreatments = useSelector(getTreatments);

  const promoAreaEnabled = splitTreatments?.deals_promo_area?.treatment === 'on';

  useEffect(() => {
    if (promoAreaEnabled && !isEqual(query, previousQuery)) {
      dispatch(fetchDeals());
      setPreviousQuery(query);
    }
  }, [query, dispatch, promoAreaEnabled, previousQuery]);

  return null;
};

export default PromoAreaDealsFetcher;
